import React from "react";

// Thin (1.5px) outline icons so the side menu matches the Cisco-style look.
const PATHS = {
  "activity planner": "M4 5h16v15H4zM4 10h16M8 3v4M16 3v4M9 15l2 2 4-4",
  "attendance": "M9 11a3 3 0 100-6 3 3 0 000 6zM3 20c0-3 3-5 6-5s6 2 6 5M16 11l2 2 4-4",
  "assignment": "M7 4h10v17H7zM10 3h4v3h-4zM10 11h4M10 15h4",
  "lesson plan": "M3 5c3-1 6-1 9 1 3-2 6-2 9-1v14c-3-1-6-1-9 1-3-2-6-2-9-1zM12 6v14",
  "language": "M4 5h8M8 3v2M5 9c1 3 3 5 6 6M11 9c-1 3-3 5-6 6M13 20l4-9 4 9M14.5 17h5",
  "calendar of events": "M4 5h16v15H4zM4 10h16M8 3v4M16 3v4M8 14h2M12 14h2M16 14h.5",
  "event reminders": "M6 16V11a6 6 0 1112 0v5l2 2H4zM10 21h4",
  "captured moments": "M3 5h18v14H3zM3 16l5-5 4 4 3-3 6 5M9 9.5h.01",
  "notes for report": "M6 3h9l4 4v14H6zM9 12h7M9 16h4",
  "reports": "M4 4v16h16M8 16v-4M12 16V8M16 16v-6",
  "training session": "M3 4h18v12H3zM8 20h8M12 16v4",
  "user manual": "M5 3h14v18H5zM5 14h14M9 7h6",
  "student details": "M9 11a3 3 0 100-6 3 3 0 000 6zM3 20c0-3 3-5 6-5s6 2 6 5M17 10a2.5 2.5 0 100-5M17 15c2.5 0 4 1.5 4 4",
  "class": "M4 20V8l8-5 8 5v12zM10 20v-6h4v6",
  "teacher": "M3 8l9-4 9 4-9 4zM7 10v5c0 1.5 2.5 3 5 3s5-1.5 5-3v-5",
  "special observation": "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zM12 15a3 3 0 100-6 3 3 0 000 6z",
  "dashboard": "M3 11l9-8 9 8M5 10v10h14V10",
  "section": "M4 5h7v7H4zM13 5h7v7h-7zM4 14h7v6H4zM13 14h7v6h-7z",
  "today's teacher report": "M6 3h9l4 4v14H6zM9 12h7M9 16h4M9 8h3",
  "add lesson": "M3 5c3-1 6-1 9 1 3-2 6-2 9-1v14c-3-1-6-1-9 1-3-2-6-2-9-1zM12 9v6M9 12h6",
  "activity catalogue": "M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z",
  "annual events & holiday\u2019s calendar": "M4 5h16v15H4zM4 10h16M8 3v4M16 3v4M8 14h2M12 14h2M16 14h.5",
  "calendar": "M4 5h16v15H4zM4 10h16M8 3v4M16 3v4M8 14h2M12 14h2M16 14h.5",
  "notification": "M6 16V11a6 6 0 1112 0v5l2 2H4zM10 21h4",
  "notifications": "M6 16V11a6 6 0 1112 0v5l2 2H4zM10 21h4",
  "fee": "M3 6h18v12H3zM3 10h18M7 15h3",
  "fee payments": "M3 6h18v12H3zM3 10h18M7 15h3",
  "enquiry form": "M5 3h14v18H5zM9 8h6M9 12h6M9 16h3",
  "food": "M7 3v8M5 3v5a2 2 0 004 0V3M7 11v10M17 3c-2 2-2 6 0 8v10",
  "food menu": "M7 3v8M5 3v5a2 2 0 004 0V3M7 11v10M17 3c-2 2-2 6 0 8v10",
  "food menu master": "M7 3v8M5 3v5a2 2 0 004 0V3M7 11v10M17 3c-2 2-2 6 0 8v10",
  "hand book": "M5 3h14v18H5zM5 14h14M9 7h6",
  "messages": "M4 5h16v11H9l-5 4z",
  "write a message": "M4 5h16v11H9l-5 4z",
  "activity schedule for parent": "M12 21a9 9 0 100-18 9 9 0 000 18zM12 7v5l3 2",
  "promotion": "M12 20V6M6 12l6-6 6 6M5 20h14",
  "student charge master": "M3 6h18v12H3zM3 10h18M7 15h3",
  "users & roles": "M9 11a3 3 0 100-6 3 3 0 000 6zM3 20c0-3 3-5 6-5s6 2 6 5M17 10a2.5 2.5 0 100-5M17 15c2.5 0 4 1.5 4 4",
  "app version": "M7 2h10v20H7zM11 18h2",
  "academic master": "M4 5h16v15H4zM4 10h16M8 3v4M16 3v4",
  "icon master": "M12 3l2.7 5.5 6 .9-4.4 4.2 1 6-5.3-2.8-5.3 2.8 1-6L3.3 9.4l6-.9z",
  "origin master": "M12 21s7-6 7-11a7 7 0 10-14 0c0 5 7 11 7 11zM12 12a2 2 0 100-4",
  "school usage": "M4 4v16h16M8 16v-4M12 16V8M16 16v-6",
  "trainer registration": "M9 11a3 3 0 100-6 3 3 0 000 6zM3 20c0-3 3-5 6-5s6 2 6 5M17 8v6M14 11h6",
  "training topics": "M3 4h18v12H3zM8 20h8M12 16v4",
  "activity progress": "M4 4v16h16M7 15l4-4 3 3 5-6",
  "student story": "M3 5c3-1 6-1 9 1 3-2 6-2 9-1v14c-3-1-6-1-9 1-3-2-6-2-9-1zM12 6v14",
  "helpful information": "M12 21a9 9 0 100-18 9 9 0 000 18zM12 11v5M12 8v.5",
  "notes": "M6 3h9l4 4v14H6zM9 12h7M9 16h4",
  "school details": "M3 9l9-5 9 5M5 9v10h14V9M9 19v-6h6v6",
};

export const hasThinIcon = (label) => Boolean(PATHS[String(label || "").trim().toLowerCase()]);

export default function ThinIcon({ label, size = 22 }) {
  const d = PATHS[String(label || "").trim().toLowerCase()];
  if (!d) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={d} />
    </svg>
  );
}
